'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyledSelect = undefined;

var _contains2 = require('ramda/src/contains');

var _contains3 = _interopRequireDefault(_contains2);

var _prop2 = require('ramda/src/prop');

var _prop3 = _interopRequireDefault(_prop2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n    ', '\n\n    &.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n        ', '\n        border-color: #d1dbe7;\n        border-radius: 1px;\n        box-shadow: none !important;\n    }\n\n    &.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {\n        border-color: #a3b8d0;\n        box-shadow: none;\n        outline: 0;\n    }\n\n    &.ant-select:not(.ant-select-disabled):hover .ant-select-selector {\n        border-color: #a3b8d0;\n    }\n\n    .ant-select-selection-selected-value {\n        border-radius: 0px 8px 8px 0px;\n        height: 36px;\n    }\n\n    &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n        ', '\n    }\n    &.ant-select-single .ant-select-selector .ant-select-selection-item, &.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n        line-height: 34px;\n    }\n    .ant-select-arrow {\n        color: #a3b8d0;\n    }\n\n    &.ant-select-multiple .ant-select-selection-item {\n        border: 1px solid #d1dbe7;\n    }\n\n    &.ant-select.ant-select-disabled .ant-select-selection-item {\n        color: #000;\n    }\n    &.ant-select .ant-select-selection-placeholder {\n        color: #bfbfbf;\n        opacity: 1;\n    }\n'], ['\n    width: 100%;\n    ', '\n\n    &.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n        ', '\n        border-color: #d1dbe7;\n        border-radius: 1px;\n        box-shadow: none !important;\n    }\n\n    &.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {\n        border-color: #a3b8d0;\n        box-shadow: none;\n        outline: 0;\n    }\n\n    &.ant-select:not(.ant-select-disabled):hover .ant-select-selector {\n        border-color: #a3b8d0;\n    }\n\n    .ant-select-selection-selected-value {\n        border-radius: 0px 8px 8px 0px;\n        height: 36px;\n    }\n\n    &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n        ', '\n    }\n    &.ant-select-single .ant-select-selector .ant-select-selection-item, &.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n        line-height: 34px;\n    }\n    .ant-select-arrow {\n        color: #a3b8d0;\n    }\n\n    &.ant-select-multiple .ant-select-selection-item {\n        border: 1px solid #d1dbe7;\n    }\n\n    &.ant-select.ant-select-disabled .ant-select-selection-item {\n        color: #000;\n    }\n    &.ant-select .ant-select-selection-placeholder {\n        color: #bfbfbf;\n        opacity: 1;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _experiumPlayerHelpers = require('experium-player-helpers');

var _withFieldWrapper = require('../hocs/withFieldWrapper');

var _withFieldWrapper2 = _interopRequireDefault(_withFieldWrapper);

require('antd/lib/select/style/index.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledSelect = exports.StyledSelect = (0, _styledComponents2.default)(_select2.default)(_templateObject, function (_ref) {
    var mode = _ref.mode;
    return mode ? 'min-height: 36px;' : 'height: 36px;';
}, function (_ref2) {
    var mode = _ref2.mode;
    return mode ? 'min-height: 36px;' : 'height: 36px;';
}, function (_ref3) {
    var mode = _ref3.mode;
    return mode ? 'min-height: 36px;' : 'height: 36px;';
});

var SelectComponent = function (_Component) {
    _inherits(SelectComponent, _Component);

    function SelectComponent() {
        var _ref4;

        var _temp, _this, _ret;

        _classCallCheck(this, SelectComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = SelectComponent.__proto__ || Object.getPrototypeOf(SelectComponent)).call.apply(_ref4, [this].concat(args))), _this), _this.onChange = function (val, props) {
            var value = (0, _prop3.default)('value', props) || val;

            _this.props.onChange(value);
        }, _this.onChangeMultiple = function (val, props) {
            var value = (0, _prop3.default)('value', props) || val;

            _this.props.onChange(value && value.length ? value : null);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SelectComponent, [{
        key: 'getOptions',
        value: function getOptions() {
            var _props = this.props,
                language = _props.language,
                options = _props.options;


            return options.map(function (option) {
                return {
                    value: option.id,
                    label: (0, _experiumPlayerHelpers.getText)(option, language) || ' '
                };
            });
        }
    }, {
        key: 'isMultiple',
        value: function isMultiple() {
            return this.props.item.select && this.props.item.select.selection === 'multiple';
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                value = _props2.value,
                disabled = _props2.disabled,
                required = _props2.required,
                options = _props2.options,
                label = _props2.label;

            var isMultiple = this.isMultiple();

            return _react2.default.createElement(StyledSelect, {
                mode: isMultiple ? 'multiple' : undefined,
                value: isMultiple ? value || [] : value,
                onChange: isMultiple ? this.onChangeMultiple : this.onChange,
                options: this.getOptions(),
                showSearch: options && options.length > 8,
                filterOption: function filterOption(input, option) {
                    return (0, _contains3.default)(('' + input).toLowerCase(), ('' + option.label).toLowerCase());
                },
                allowClear: !required || isMultiple,
                disabled: disabled,
                placeholder: label,
                notFoundContent: _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'empty' })
            });
        }
    }]);

    return SelectComponent;
}(_react.Component);

SelectComponent.propTypes = {
    disabled: _propTypes2.default.bool,
    value: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
    item: _propTypes2.default.object,
    onChange: _propTypes2.default.func,
    options: _propTypes2.default.array,
    language: _propTypes2.default.string,
    label: _propTypes2.default.string,
    required: _propTypes2.default.bool
};
exports.default = (0, _withFieldWrapper2.default)(SelectComponent);